var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTPQuestionForm',{attrs:{"questionObject":_vm.question,"formActionName":"إنشاء السؤال"},on:{"questionSubmitted":function (submittedQuestion) { return _vm.sendQuestionData(submittedQuestion); }}})}
var staticRenderFns = []

export { render, staticRenderFns }